module.exports = __webpack_public_path__ + "2f8514a612424bbc64656bee906b511d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/snake.svg
// module id = 95
// module chunks = 0